import styles from './custom-checkbox-wrapper.module.scss';

import { Button } from 'native-base';
import { theme } from '@breakroom-nx/assets';
import { useState } from 'react';

export interface CustomCheckboxWrapperProps {
  // Required
  title: string;
  counterValue: number;

  // Optional
  maxSelection?: number;
  setAsChecked?: boolean;
  child?: JSX.Element | JSX.Element[];

  // Function callbacks
  onCheckboxSelect: any;
  onCounterChange: any;
}

export const CustomCheckboxWrapper = ({
  title,
  counterValue,
  maxSelection = 1,
  setAsChecked = false,
  child = undefined,

  // Function callbacks
  onCheckboxSelect,
  onCounterChange,
}: CustomCheckboxWrapperProps) => {
  const [checked, setChecked] = useState(setAsChecked);
  const isDisabled = !checked && counterValue >= maxSelection;

  return (
    <Button
      _hover={{
        backgroundColor: checked
          ? theme.colors.primary[100]
          : theme.colors.surface[300],
      }}
      isDisabled={isDisabled}
      onPress={() => {
        setChecked(!checked);
        onCheckboxSelect(title);
        onCounterChange(!checked ? 1 : -1);
      }}
      _pressed={{
        backgroundColor: checked
          ? theme.colors.primary[100]
          : theme.colors.surface[200],
      }}
      rounded={'10'}
      borderRadius={'10'}
      borderColor={
        checked ? theme.colors.primary[400] : theme.colors.surface[300]
      }
      borderWidth={1.5}
      bg={checked ? theme.colors.primary[100] : 'transparent'}
      style={{ opacity: isDisabled ? 0.2 : 1 }}
      p={0}
    >
      {child}
    </Button>
  );
};

export default CustomCheckboxWrapper;
